import { createAction } from 'redux-actions';

import types from './types';

const initialize = createAction(types.INITIALIZE);
const loadReviews = createAction(types.LOAD_REVIEWS);
const loadMoreReviews = createAction(types.LOAD_MORE_REVIEWS);
const setReviews = createAction(types.SET_REVIEWS);
const setMoreReviews = createAction(types.SET_MORE_REVIEWS);
const setLoading = createAction(types.SET_LOADING);
const setCurrentPage = createAction(types.SET_CURRENT_PAGE);
const tryIncrementPage = createAction(types.TRY_INCREMENT_PAGE);
const tryDecrementPage = createAction(types.TRY_DECREMENT_PAGE);
const setNumberOfItemsPerPage = createAction(types.SET_NUMBER_OF_ITEMS_PER_PAGE);
const addFilter = createAction(types.ADD_ACTIVE_FILTER);
const setFilter = createAction(types.SET_ACTIVE_FILTER);
const removeFilter = createAction(types.REMOVE_ACTIVE_FILTER);
const removeAllFilters = createAction(types.REMOVE_ALL_FILTERS);
const filterReviews = createAction(types.FILTER_REVIEWS);
const setSort = createAction(types.SET_SORT);
const setSortDefault = createAction(types.SET_SORT_DEFAULT);
const setProductCode = createAction(types.SET_PRODUCT_CODE);
const openExternalReviewsVendor = createAction(types.OPEN_EXTERNAL_REVIEWS_VENDOR);
const reportReview = createAction(types.REPORT_REVIEW);
const setReportedReviews = createAction(types.SET_REPORTED_REVIEWS);
const loadReportedReviews = createAction(types.LOAD_REPORTED_REVIEWS);
const voteForReview = createAction(types.VOTE_FOR_REVIEW);
const setReaction = createAction(types.SET_REACTION);
const setLoadedReactions = createAction(types.SET_LOADED_REACTIONS);
const setCurrentReview = createAction(types.SET_CURRENT_REVIEW);
const translateReview = createAction(types.TRANSLATE_REVIEW);
const setShowTranslatedReview = createAction(types.SET_SHOW_TRANSLATED_REVIEW);
const setTranslation = createAction(types.SET_TRANSLATION);
const setNeedsTranslation = createAction(types.SET_NEEDS_TRANSLATION);
const setTranslationLoading = createAction(types.SET_TRANSLATION_LOADING);
const setGoogleApiKey = createAction(types.SET_GOOGLE_API_KEY);
const reportEnhancedReview = createAction(types.REPORT_ENHANCED_REVIEW);
const increaseLoadIteration = createAction(types.INCREASE_LOAD_ITERATION);
const resetCurrent = createAction(types.RESET_CURRENT);

export default {
    initialize,
    loadReviews,
    loadMoreReviews,
    setReviews,
    setMoreReviews,
    setCurrentPage,
    tryIncrementPage,
    tryDecrementPage,
    setNumberOfItemsPerPage,
    setLoading,
    addFilter,
    setFilter,
    removeFilter,
    removeAllFilters,
    filterReviews,
    setSort,
    setSortDefault,
    setProductCode,
    openExternalReviewsVendor,
    reportReview,
    setReportedReviews,
    loadReportedReviews,
    voteForReview,
    setReaction,
    setLoadedReactions,
    setCurrentReview,
    translateReview,
    setShowTranslatedReview,
    setTranslation,
    setNeedsTranslation,
    setTranslationLoading,
    setGoogleApiKey,
    reportEnhancedReview,
    increaseLoadIteration,
    resetCurrent,
};
